module.exports = __webpack_public_path__ + "img/zi.ef92798e.png";